module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0037.70ffa6e5.jpg";